export default __webpack_public_path__ + "static/media/silvia1.9c43403b.png";